<div class="guardar-dialog condicion-dialog dialog-bordered editar-parametros"
     [ngClass]="{ 'dark-theme': isDark, 'light-theme': !isDark }"
     cdkDrag cdkDragRootElement=".cdk-overlay-pane" [cdkDragDisabled]="!ventana.flotante"
     [class.ventana-flotante]="ventana.flotante" [class.ventana-minimizada]="ventana.isMinimized">

  <!-- Header fijo -->
  <div class="guardar-header d-flex align-items-center justify-content-between header-bordered sticky-top ventana-asa" cdkDragHandle>
    <h2 class="guardar-title ventana-titulo m-0">
      <mat-icon class="me-2">tune</mat-icon>
      Parámetros
    </h2>
    <div class="d-flex align-items-center gap-2">
      <!--span class="param-count" *ngIf="params?.length">({{ params.length }} parámetros)</span-->
      <button mat-icon-button class="close-button ventana-btn-minimizar" *ngIf="ventana.flotante" (click)="ventana.toggle()"
              [title]="ventana.isMinimized ? 'Restaurar' : 'Minimizar'" [attr.aria-label]="ventana.isMinimized ? 'Restaurar' : 'Minimizar'">
        <mat-icon>{{ ventana.isMinimized ? 'open_in_full' : 'remove' }}</mat-icon>
      </button>
      <button mat-icon-button class="close-button" (click)="onCancel()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Contenido con scroll propio -->
  <div class="guardar-content scroll-content">
    <div class="template-preview mb-3" *ngIf="conditionTemplate">
      <div class="preview-label seccion-plegable" role="button" tabindex="0" (click)="togglePlegar('condicion')" (keydown.enter)="togglePlegar('condicion')" [attr.aria-expanded]="!plegada['condicion']" title="Clic para mostrar/ocultar">
        <mat-icon class="small-icon chevron-plegar">{{ plegada['condicion'] ? 'chevron_right' : 'expand_more' }}</mat-icon>
        <mat-icon class="small-icon">code</mat-icon>
        Condición:
      </div>
      <code class="d-block preview-code" [hidden]="plegada['condicion']" [innerHTML]="getHighlightedTemplate()" [attr.title]="conditionTemplate"></code>
    </div>

    <div *ngIf="!params.length" class="alert-no-numbers">
      No se detectaron números editables en la condición.
    </div>

    <form [formGroup]="form" *ngIf="params.length">
      <!-- Vista compacta en tabla -->
      <ng-container *ngIf="viewCompact; else cardView">
        <div class="section-header seccion-plegable" [class.plegada]="plegada['parametros']" role="button" tabindex="0" (click)="togglePlegar('parametros')" (keydown.enter)="togglePlegar('parametros')" [attr.aria-expanded]="!plegada['parametros']" title="Clic para mostrar/ocultar">
          <mat-icon class="small-icon chevron-plegar">{{ plegada['parametros'] ? 'chevron_right' : 'expand_more' }}</mat-icon>
          <mat-icon class="small-icon">settings</mat-icon>
          <span>Parámetros de la condición</span>
          <span class="seccion-resumen" *ngIf="plegada['parametros']">({{ params.length }})</span>
        </div>
        <div formArrayName="parametros" class="params-cols" [class.dos-columnas]="dosColumnas" [hidden]="plegada['parametros']">
         <div class="params-table-wrapper" *ngFor="let col of columnasParams">
          <table class="params-table">
            <thead>
              <tr>
                <th class="idx">#</th>
                <th>Orig.</th>
                <th>Inicio</th>
                <th>Final</th>
                <th>Paso</th>
                <th class="count">Val.</th>
                <th class="actions"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let i of col">
              <tr *ngIf="parametrosFA.at(i) as p" [formGroupName]="i">
                <td class="idx"><code class="d-block preview-code2">{{ '{{p' + i + '}}' }}</code></td>
                <td class="original">{{ p.get('original')?.value }}</td>
                <td>
                  <input class="dense-input" type="number" formControlName="start" [step]="params[i].step"
                         (focus)="setActiveParam(i)" (blur)="setActiveParam(null)">
                </td>
                <td>
                  <input class="dense-input" type="number" formControlName="end" [step]="params[i].step"
                         (focus)="setActiveParam(i)" (blur)="setActiveParam(null)">
                </td>
                <td>
                  <input class="dense-input" type="number" formControlName="step" min="0" [step]="params[i].step"
                         (focus)="setActiveParam(i)" (blur)="setActiveParam(null)">
                </td>
                <td class="count"><ng-container *ngIf="p.valid">{{ valueCount(p) }}</ng-container></td>
                <td class="actions">
                  <button mat-icon-button type="button" class="btn-restore" (click)="restoreOriginal(i)" matTooltip="Restablecer">
                    <mat-icon>restore</mat-icon>
                  </button>
                </td>
              </tr>
              </ng-container>
            </tbody>
          </table>
         </div>
        </div>

        <!-- Rangos adicionales en formato compacto -->
        <div class="section-header seccion-plegable mt-3" [class.plegada]="plegada['rangos']" role="button" tabindex="0" (click)="togglePlegar('rangos')" (keydown.enter)="togglePlegar('rangos')" [attr.aria-expanded]="!plegada['rangos']" title="Clic para mostrar/ocultar">
          <mat-icon class="small-icon chevron-plegar">{{ plegada['rangos'] ? 'chevron_right' : 'expand_more' }}</mat-icon>
          <mat-icon class="small-icon">speed</mat-icon>
          <span>Rangos adicionales</span>
        </div>
        <div class="params-table-wrapper" [hidden]="plegada['rangos']">
          <table class="params-table">
            <thead>
              <tr>
                <th>Rango</th>
                <th>Original</th>
                <th>Inicio</th>
                <th>Final</th>
                <th>Paso</th>
                <th class="count">Valores</th>
              </tr>
            </thead>
            <tbody>
              <tr formGroupName="stopLoss">
                <td>Stop Loss</td>
                <td class="original">{{ form.get('stopLoss.original')?.value }}</td>
                <td><input class="dense-input" type="number" formControlName="start" [step]="form.get('stopLoss.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td><input class="dense-input" type="number" formControlName="end" [step]="form.get('stopLoss.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td><input class="dense-input" type="number" formControlName="step" [step]="form.get('stopLoss.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td class="count">{{ valueCount(form.get('stopLoss')!) }}</td>
              </tr>
              <tr formGroupName="profit">
                <td>Profit</td>
                <td class="original">{{ form.get('profit.original')?.value }}</td>
                <td><input class="dense-input" type="number" formControlName="start" [step]="form.get('profit.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td><input class="dense-input" type="number" formControlName="end" [step]="form.get('profit.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td><input class="dense-input" type="number" formControlName="step" [step]="form.get('profit.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td class="count">{{ valueCount(form.get('profit')!) }}</td>
              </tr>
              <tr formGroupName="diasSalida">
                <td>Días de salida</td>
                <td class="original">{{ form.get('diasSalida.original')?.value }}</td>
                <td><input class="dense-input" type="number" formControlName="start" [step]="form.get('diasSalida.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td><input class="dense-input" type="number" formControlName="end" [step]="form.get('diasSalida.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td><input class="dense-input" type="number" formControlName="step" [step]="form.get('diasSalida.step')?.value || 1" min="1"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td class="count">{{ valueCount(form.get('diasSalida')!) }}</td>
              </tr>
              <tr formGroupName="riesgo">
                <td>Riesgo</td>
                <td class="original">{{ valorriesgooriginal }}</td>
                <td><input class="dense-input" type="number" formControlName="start" [step]="form.get('riesgo.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td><input class="dense-input" type="number" formControlName="end" [step]="form.get('riesgo.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td><input class="dense-input" type="number" formControlName="step" [step]="form.get('riesgo.step')?.value || 1" min="0"
                           (focus)="setActiveParam(null)" (blur)="setActiveParam(null)"></td>
                <td class="count">{{ valueCount(form.get('riesgo')!) }}</td>
              </tr>

            </tbody>
          </table>
        </div>
      </ng-container>

      <!-- Vista tarjetas (original) -->
      <ng-template #cardView>
        <div formArrayName="parametros" class="params-list">
          <div class="param-item"
               *ngFor="let p of parametrosFA.controls; let i = index; trackBy: trackByIndex"
               [formGroupName]="i">

            <div class="param-header">
              <strong>Parámetro {{ i + 1 }}</strong>
              <span class="original">Original: {{ p.get('original')?.value }}</span>
            </div>

            <div class="inputs-grid">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Inicio</mat-label>
      <input matInput type="number" formControlName="start" [step]="params[i].step"
        (focus)="setActiveParam(i)" (blur)="setActiveParam(null)">
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Final</mat-label>
      <input matInput type="number" formControlName="end" [step]="params[i].step"
        (focus)="setActiveParam(i)" (blur)="setActiveParam(null)">
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Paso</mat-label>
      <input matInput type="number" formControlName="step" min="0" [step]="params[i].step"
        (focus)="setActiveParam(i)" (blur)="setActiveParam(null)">
              </mat-form-field>
            </div>

            <div class="param-footer d-flex align-items-center justify-content-between">
              <button mat-stroked-button color="primary" type="button" (click)="restoreOriginal(i)">
                Restablecer
              </button>
              <span class="count small" *ngIf="p.valid">
                Valores: {{ valueCount(p) }}
              </span>
            </div>

          </div>
        </div>
        <!-- Rangos adicionales: Stop Loss, Profit y Días de Salida -->
        <div class="param-item mt-3" formGroupName="stopLoss">
          <div class="param-header">
            <strong>Stop Loss</strong>
            <span class="original">Original: {{ form.get('stopLoss.original')?.value }}</span>
          </div>
          <div class="inputs-grid">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inicio</mat-label>
              <input matInput type="number" formControlName="start" [step]="form.get('stopLoss.step')?.value || 1" min="0">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Final</mat-label>
              <input matInput type="number" formControlName="end" [step]="form.get('stopLoss.step')?.value || 1" min="0">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Paso</mat-label>
              <input matInput type="number" formControlName="step" [step]="form.get('stopLoss.step')?.value || 1" min="0">
            </mat-form-field>
          </div>
          <div class="param-footer d-flex align-items-center justify-content-between">
            <span></span>
            <span class="count small">Valores: {{ valueCount(form.get('stopLoss')!) }}</span>
          </div>
        </div>

        <div class="param-item mt-3" formGroupName="profit">
          <div class="param-header">
            <strong>Profit</strong>
            <span class="original">Original: {{ form.get('profit.original')?.value }}</span>
          </div>
          <div class="inputs-grid">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inicio</mat-label>
              <input matInput type="number" formControlName="start" [step]="form.get('profit.step')?.value || 1" min="0">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Final</mat-label>
              <input matInput type="number" formControlName="end" [step]="form.get('profit.step')?.value || 1" min="0">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Paso</mat-label>
              <input matInput type="number" formControlName="step" [step]="form.get('profit.step')?.value || 1" min="0">
            </mat-form-field>
          </div>
          <div class="param-footer d-flex align-items-center justify-content-between">
            <span></span>
            <span class="count small">Valores: {{ valueCount(form.get('profit')!) }}</span>
          </div>
        </div>

        <div class="param-item mt-3" formGroupName="diasSalida">
          <div class="param-header">
            <strong>Días de salida</strong>
            <span class="original">Original: {{ form.get('diasSalida.original')?.value }}</span>
          </div>
          <div class="inputs-grid">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inicio</mat-label>
              <input matInput type="number" formControlName="start" [step]="form.get('diasSalida.step')?.value || 1" min="0">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Final</mat-label>
              <input matInput type="number" formControlName="end" [step]="form.get('diasSalida.step')?.value || 1" min="0">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Paso</mat-label>
              <input matInput type="number" formControlName="step" [step]="form.get('diasSalida.step')?.value || 1" min="1">
            </mat-form-field>
          </div>
          <div class="param-footer d-flex align-items-center justify-content-between">
            <span></span>
            <span class="count small">Valores: {{ valueCount(form.get('diasSalida')!) }}</span>
          </div>
        </div>
      </ng-template>
    </form>

    <div class="summary mt-4" *ngIf="params.length">
      <mat-icon class="small-icon me-2">calculate</mat-icon>
      <strong>Total combinaciones:</strong> {{ combinations() | number }}
    </div>
  </div>

  <!-- Acciones fijas abajo -->
  <div class="guardar-actions d-flex justify-content-end gap-2 actions-sticky">
    <button mat-stroked-button (click)="onCancel()">
      <mat-icon class="me-1">close</mat-icon>
      Cancelar
    </button>
    <button mat-raised-button color="primary"
            (click)="onSave()"
            [disabled]="form.invalid || !params.length || !cargado">
      <mat-icon class="me-1" aria-hidden="true">auto_fix_high</mat-icon>
       Optimizar
    </button>
  </div>
</div>